import { InjectionToken } from '@angular/core';

export const PUSH_CONFIGURATION_TOKEN = new InjectionToken<IPushConfiguration>('PushConfigurationToken');
export interface IPushConfiguration {
  isProd(): boolean;
  getUrl(): string;
}
